import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class GrayStoneFloor2 extends Floor {
	static key = "GrayStoneFloor2";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): GrayStoneFloor2 {
		const f = new GrayStoneFloor2(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
